<template>
     <el-row span="24">
        <el-col :span="24">
            <el-form ref="form" label-position="top">
                <el-row :gutter="25">
                    <el-col :sm="24" :md="24" :lg="24">
                        <el-form-item class="el-form-item-full" :label="$l('settings/adio/Present')">
                            <el-select v-model="getSettingsAdio.present" :placeholder="$l('common/select')">
                                <el-option :label="$l('settings/adio/NoDevice')" value="0"></el-option>
                                <el-option :label="$l('settings/adio/ADIO')" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/adio/DigitalOut') + ' 0'">
                            <el-switch on-text="" off-text="" v-model="getSettingsAdio.DO1" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>

                    <el-col :sm="12" :md="12" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/adio/DigitalIn') + ' 0'">
                            <el-switch on-text="" off-text="" v-model="getSettingsAdio.DI1" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :sm="12" :md="12" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/adio/DigitalOut') + ' 1'">
                            <el-switch on-text="" off-text="" v-model="getSettingsAdio.DO2" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>

                    <el-col :sm="12" :md="12" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/adio/DigitalIn') + ' 1'">
                            <el-switch on-text="" off-text="" v-model="getSettingsAdio.DI2" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>

                    <el-col :sm="12" :md="12" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/adio/AnalogIn')">
                            <el-switch on-text="" off-text="" v-model="getSettingsAdio.AI" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/adio/AnalogOut')">
                            <el-switch on-text="" off-text="" v-model="getSettingsAdio.AO" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>

                    <el-col :sm="12" :md="12" :lg="12">
                        <el-row :gutter="25">
                            <el-col :sm="11" :lg="11">
                                <el-form-item class="el-form-item-full" :label="$l('settings/adio/AnalogLowerLimit')">
                                    <el-input-number :disabled="getSettingsAdio.AI == 0" v-model="getSettingsAdio.AILower" style="width: 100%;"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col class="line" :sm="2" :lg="2">
                                <el-form-item class="el-form-item-full pixel" label=" ">-</el-form-item>
                            </el-col>
                            <el-col :sm="11" :lg="11">
                                <el-form-item class="el-form-item-full" :label="$l('settings/adio/AnalogUpperLimit')">
                                    <el-input-number :disabled="getSettingsAdio.AI == 0" v-model="getSettingsAdio.AIUpp" style="width: 100%;"></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <el-row :gutter="25">
                            <el-col :sm="11" :lg="11">
                                <el-form-item class="el-form-item-full" :label="$l('settings/adio/AnalogLowerLimit')">
                                    <el-input-number :min="-10" :max="140" :disabled="getSettingsAdio.AO == 0" v-model="getSettingsAdio.AOLower" style="width: 100%;"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col class="line" :sm="2" :lg="2">
                                <el-form-item class="el-form-item-full pixel" label=" ">-</el-form-item>
                            </el-col>
                            <el-col :sm="11" :lg="11">
                                <el-form-item class="el-form-item-full" :label="$l('settings/adio/AnalogUpperLimit')">
                                    <el-input-number :min="-10" :max="140" :disabled="getSettingsAdio.AO == 0" v-model="getSettingsAdio.AOUpp" style="width: 100%;"></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-form>
        </el-col>
        
    </el-row>
</template>

<style scoped>
    .pixel{
        margin-top:5px;
    }
</style>

<script>
import { mapGetters } from 'vuex'
export default {
    computed:{
         ...mapGetters([
            'getSettingsAdio',
            'getSettingsVideo'
        ]),
    },
}
</script>





// WEBPACK FOOTER //
// Adio.vue?9ab8e8c4